import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess, markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { getGeoApiData } from "@MasterBluePrint/Services/GeoService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { GeoCodeSettingsModel } from "@MasterBluePrint/Types/ApiModels";

type HandlerType = ApiHandler<HasOnSuccess<string> & {daysToKeepCookie: number; defaultCountryCode: string;}, string>;
const cookieName = "CurrentCountryCode";

export const RequestDataFromApi: HandlerType = async props => {
    let currentCountryCode = getCookie(cookieName);
    // if no country code found in cookie, get it from api.
    if (!currentCountryCode){
        const geoSettings = getSettingsCollection(props.getState()).geoCodeSettings as GeoCodeSettingsModel;

        if (geoSettings?.geoCodeEnabled){
            const apiResponse = await getGeoApiData(geoSettings.apiUrl, geoSettings.apiKey);
            if (apiResponse.successful)
            {
                currentCountryCode = apiResponse.result?.countryCode;
            }
        }

        if (!currentCountryCode){
            currentCountryCode = props.parameter.defaultCountryCode;
        }

        setCookie(cookieName, currentCountryCode, {expires: props.parameter.daysToKeepCookie});
    }

    props.apiResult = currentCountryCode;
}

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
];

const getCurrentCountry = createHandlerChainRunner(chain, "GetCurrentCountry");
export default getCurrentCountry;